module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_C.bdf1051f.mp3";